import Vue from 'vue';
import {Orion} from '@tailflow/laravel-orion/lib/orion';
import * as VueGoogleMaps from 'vue2-google-maps';
import Chalet from '../Chalet';
import AvailabilityPriceSelector from '../AvailabilityPriceSelector.vue';
import Money from '../Money.vue';
import CurrencySelect from '../CurrencySelect.vue';

var config = window.config || {
    url: window.location.origin,
    site: 1,
};

Orion.init(config.url, 'sapi');
Orion.setToken('access-token-here');

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyDRceJAZP2sctL_LZO1rRbqG1igEsQAWUs',
    },
});

var mountElement = document.getElementById('chalet-page-app');

if (mountElement) {
    new Vue({
        el: mountElement,
        components: {
            chalet: Chalet,
            'availability-price-selector': AvailabilityPriceSelector,
            money: Money,
            'currency-select': CurrencySelect,
        },
        data: function ()
        {
            return {
                config: config,
                currency: null,
                availabilityPriceType: mountElement.getAttribute('data-initial-price-type') || 'catered',
                showing_chalet_enquiry_modal: false,
            };
        },
        methods: {
            show_booking_modal: function ()
            {
                this.showing_chalet_enquiry_modal = true;

                if (window.jQuery && window.jQuery.fn.modal) {
                    window.jQuery('#enquiryForm').modal({
                        backdrop: false,
                        show: true,
                    });
                }
            },
        },
    });
}
